import { ChevronLeft } from "lucide-react";
import React from "react";

type AuthNavigationHeaderProps = {
  onBackClick?: () => void;
  backToLogin?: boolean;
};

export const AuthNavigationHeader: React.FC<AuthNavigationHeaderProps> = ({
  onBackClick,
  backToLogin = false,
}) => {
  const backText = backToLogin ? "Login" : "Homepage";

  return (
    <header className="bg-[var(--color-bg-surface)] h-20 shrink-0 sticky top-0 w-full z-20 border-b border-[var(--color-bg-muted)]">
      <div className="max-w-[1280px] mx-auto h-full flex items-center px-8">
        <button
          type="button"
          onClick={onBackClick}
          className="flex items-center gap-2 text-[16px] font-semibold leading-6 text-[var(--color-text-secondary)] hover:text-[var(--color-text-secondary)] transition-colors"
        >
          <ChevronLeft className="size-5 text-[var(--color-text-muted)]" strokeWidth={1.66667} />
          <span>
            Back
            <span className="hidden lg:inline"> to {backText}</span>
          </span>
        </button>
      </div>
    </header>
  );
};
